import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Popup5498 from '@/components/ui/5498Popup';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form5498 = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Now Accepting <span style="color:#1da94a; font-weight: 600;">Form 1098-E</span> for Tax Year 2024!`,
  //   SubHeading: 'File your student loan interest deductions with ease.  ',
  //   CtaText: ' Get Started Today!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098e`,
  //   isActive: true,
  // };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 2, 2));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 2, 2)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
            color: '#fff',
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            color: '#fff',
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form 5498 Online for 2025 | TaxZerone"
          description="File IRS Form 5498 for 2025 online with TaxZerone. Report all IRA contributions, rollovers, and conversions to stay compliant with IRS filing requirements."
          keywords=""
          canonical="information-returns/efile-irs-form-5498/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Popup5498 />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Today&apos;s the Final Day to E-file Form 1099-NEC!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Time is running out! Make sure you file your <b>Form 1099-NEC</b>{' '}
              for non-employee compensation today, <b>January 31st</b>.
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background:
              'linear-gradient(92deg,rgba(0, 142, 158, 1) 0%, rgba(156, 88, 0, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Typography
                component="div"
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                  color: '#e3e3e3',
                  lineHeight: 1.3,
                }}
              >
                <strong>📢 Deadline Has Passed!</strong> E-file{' '}
                <b style={{ fontWeight: 600, color: '#fff' }}>Form 5498 </b>{' '}
                today to report your 2025 IRA contributions and avoid penalties.
              </Typography>
            </Box>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-file{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 5498</span>
                </span>{' '}
                Online
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Looking to report IRA contributions information?
                </span>{' '}
                File Form 5498 quickly and accurately through our{' '}
                <span style={{ fontWeight: 600 }}>IRS-authorized</span> e-file
                solution.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
                  >
                    Start Filing Now{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      1099-NEC
                    </Box> */}
                  </Button>
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/5498-landing-img.webp" />
                <source srcSet="/assets/images/5498-landing-img.png" />
                <img
                  src="/assets/images/5498-landing-img.png"
                  alt="E-file Form 5498 Online"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/5498-landing-img-sm.webp" />
                <source srcSet="/assets/images/5498-landing-img-sm.png" />
                <img
                  src="/assets/images/5498-landing-img-sm.png"
                  alt="E-file Form 5498 Online"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Starting at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with bulk filing rates as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                What is 5498 Form used for?{' '}
              </Typography>
              <Typography variant="body1">
                <span style={{ fontWeight: 600 }}> Form 5498</span> is used by
                IRA trustees or issuers to report contributions, rollovers,
                conversions, and the fair market value (FMV) of Individual
                Retirement Accounts (IRAs) to the IRS and account holders. It
                includes details on traditional, Roth, SEP, and SIMPLE IRA
                contributions, recharacterizations, and required minimum
                distributions (RMDs), helping the IRS track tax compliance and
                retirement savings.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <picture>
                <source
                  srcSet="/assets/images/ira-contribution-img.webp"
                  className="img-responsive"
                  width={650}
                  height={600}
                />
                <source
                  srcSet="/assets/images/ira-contribution-img.png"
                  className="img-responsive"
                  width={650}
                  height={600}
                />
                <img
                  src="/assets/images/ira-contribution-img.png"
                  alt="What is 5498 Form used for?"
                  className="img-responsive"
                  loading="lazy"
                  width={650}
                  height={600}
                />
              </picture>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                3 Easy Steps to File Your 5498 Tax Form
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                With TaxZerone, filing is quick and secure— just 3 steps to
                complete.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/5498-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/5498-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/5498-steps-img.png"
                  alt="3 Easy Steps to File Your 5498 Tax Form"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Account Holder & IRA Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Account Holder & IRA Information
                    </Typography>
                    <Typography variant="body1">
                      Provide the trustee or issuer’s name, address, TIN, and
                      the account holder’s name, TIN, and address.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Report Contribution & Account Details "
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Report Contribution & Account Details
                    </Typography>
                    <Typography variant="body1">
                      Enter the contribution details, rollover, and Roth IRA
                      conversions. Report the account’s fair market value and
                      any required minimum distributions.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Review & Transmit"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Transmit
                    </Typography>
                    <Typography variant="body1">
                      Review your return for accuracy, transmit it to the IRS,
                      and deliver the recipient’s copy securely via ZeroneVault
                      or postal mail.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3 }}>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Ready to e-file Form 5498 with the IRS?
                  </span>{' '}
                  Get started today with{' '}
                  <span style={{ fontWeight: 600 }}>TaxZerone’s</span> secure
                  e-filing!{' '}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,

                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
                >
                  E-File Form 5498 Now!
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Explore powerful features that simplify your e-filing process
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies the online filing process with its
                top-notch features.
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS authorized "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS authorized
                </Typography>
                <Typography variant="body1">
                  File your IRA Contribution Information Form 5498 with
                  <span style={{ fontWeight: 600 }}> TaxZerone</span>, an <br />
                  IRS-authorized e-file provider, and rest assured your filing
                  will be accepted.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Deliver Recipient Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Deliver Recipient Copies
                </Typography>
                <Typography variant="body1">
                  Send recipient copies securely via{' '}
                  <span style={{ fontWeight: 600 }}> ZeroneVault</span> or
                  postal mail for a smooth and convenient process with TaxZerone
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk filing
                </Typography>
                <Typography variant="body1">
                  TaxZerone enables bulk filing, allowing you to easily{' '}
                  <span style={{ fontWeight: 600 }}>submit multiple forms</span>{' '}
                  at once for greater efficiency.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Real-Time Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Updates
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}>Get real-time updates</span>{' '}
                  to stay informed at every step of your filing process,
                  ensuring accuracy and peace of mind.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  TaxZerone offers{' '}
                  <span style={{ fontWeight: 600 }}> affordable pricing</span>,
                  making tax filing simple and <br />
                  cost-effective for businesses of all sizes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Assistance"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Assistance
                </Typography>
                <Typography variant="body1">
                  TaxZerone’s team of experts is always ready to assist,
                  providing{' '}
                  <span style={{ fontWeight: 600 }}>personalized support</span>{' '}
                  to make your filing process easy and stress-free.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 20,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Deadlines for Filing Form 5498 for the 2025 Tax Year
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 3 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/claim-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/claim-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/claim-icon.png"
                      alt="Provide Participant Statements"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Provide Participant Statements{' '}
                  <span style={{ fontSize: 13 }}>(FMV & RMD)</span>
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    February 02, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with the IRS (e-file)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the IRS (e-file)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    June 01, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/penalty-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/penalty-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/penalty-icon.png"
                      alt="Provide IRA Contribution Information to Participants"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Provide IRA Contribution Information to Participants
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span
                    style={{ color: '#cc2936', fontSize: 20, fontWeight: 600 }}
                  >
                    June 01, 2026
                  </span>{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mt: 2, mb: 0 }}>
                  Stay compliant and meet your IRS deadlines hassle-free. Start
                  e-filing today with TaxZerone!{' '}
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,

                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
                >
                  E-File Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <Container
          maxWidth="lg"
          sx={{
            mb: 6,
            mt: { xs: -15, sm: -20 },
            backgroundColor: '#1d2337',
            backgroundBlendMode: 'soft-light',
            borderRadius: 4,
            px: { xs: 2, sm: 3 },
            py: 6,
            textAlign: 'center',
          }}
          className="curve-bg"
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              textAlign: 'center',
              color: '#fff',
            }}
          >
            Running Out of Time? File for an Extension
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: '#909090' }}>
            Get additional time to file or send recipient copies by requesting
            an extension below.
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            mx={2}
            mt={{ xs: 4, md: 4 }}
            pb={0}
            className="MuiGrid-root-width"
            sx={{}}
          >
            <Grid
              size={{ xs: 12, md: 6, sm: 6 }}
              textAlign="center"
              sx={{
                pt: '0 !important',
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 8809
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#a2a2a2' }}>
                  Extension of Time to File Information Returns
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem
                      sx={{
                        py: 0.5,
                        alignItems: 'flex-start',
                        textAlign: 'center',
                        p: 0,
                      }}
                    >
                      <ListItemText sx={{ color: '#ccc' }}>
                        Need more time to{' '}
                        <span style={{ fontWeight: 600 }}>file your 5498?</span>{' '}
                        <Link
                          href="/tax-extension/efile-irs-form-8809-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          E-file Form 8809
                        </Link>{' '}
                        to request an{' '}
                        <span style={{ fontWeight: 600 }}>
                          automatic 30-day extension
                        </span>{' '}
                        to file the 5498 with the IRS.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6, sm: 6 }}
              textAlign="center"
              sx={{
                pt: { sm: '0 !important' },
              }}
            >
              <Box
                sx={{
                  backgroundColor: 'rgba(0, 0, 0, .75)',
                  backgroundBlendMode: 'soft-light',
                  borderRadius: 4,
                  px: { xs: 2, lg: 2 },
                  py: 3,
                  minHeight: '100%',
                  border: '2px solid #353b4e',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 28, md: 24, sm: 22, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    textAlign: 'center',
                    color: '#ccc',
                  }}
                >
                  Form 15397
                </Typography>
                <Typography variant="body1" sx={{ mb: 0, color: '#909090' }}>
                  Request an Extension to Furnish Recipient Statements
                </Typography>
                <Box
                  sx={{
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    m: 0,
                    mt: 2,
                  }}
                >
                  <List sx={{ mb: 0 }}>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start', p: 0 }}>
                      <ListItemText sx={{ color: '#ccc', textAlign: 'center' }}>
                        Need more time to send recipient copies of Form 5498?{' '}
                        <Link
                          href="/tax-extension/file-irs-form-15397-online/"
                          sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                        >
                          File Form 15397
                        </Link>{' '}
                        to request a{' '}
                        <span style={{ fontWeight: 600 }}>
                          one-time 30-day extension
                        </span>{' '}
                        to furnish 5498 recipient statements.
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} textAlign="center">
              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-secondary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
              >
                Get Extension Now
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 1, fontSize: { xs: 11, sm: 14 }, color: '#a2a2a2' }}
              >
                File Extension in Mins
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Simplify Your Tax Filing with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          TaxZerone simplifies tax filing with a fast, easy, and cost-effective
          solution.
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Ensure accuracy with built-in IRS compliance checks.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Easily meet IRS reporting requirements.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Save time by filing multiple forms at once.
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Benefit from the most competitive pricing in the industry.
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Typography
            variant="body1"
            sx={{ color: '#f3f3f3', fontWeight: 500 }}
          >
            Start e-filing now and finish in just 3 simple steps!
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form5498`}
          >
            Create a Free Account Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 4 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. When are 5498 forms issued?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Form 5498 must be filed with the IRS by{' '}
                      <span style={{ fontWeight: 600 }}> May 31</span> following
                      the tax year being reported. However, you must provide
                      Copy B to the participant by{' '}
                      <span style={{ fontWeight: 600 }}>January 31</span> for
                      FMV and RMD information, and by{' '}
                      <span style={{ fontWeight: 600 }}>May 31</span> for
                      contribution information. Missing these deadlines can
                      result in penalties.
                    </Typography>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{
                        mt: 2,
                        mb: 0,
                        alignItems: 'start',
                      }}
                    >
                      <b>Note:</b> If the deadline falls on a weekend or
                      holiday, it is extended to the next business day.
                    </Alert>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What types of IRAs are reported on Form 5498?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="ul" sx={{ mb: 1, '& li': { mb: 1 } }}>
                      <li>Traditional IRA</li>
                      <li>Roth IRA </li>
                      <li>Payroll Deduction IRA </li>
                      <li>SEP IRA (Simplified Employee Pension) </li>
                      <li>
                        SIMPLE IRA (Savings Incentive Match Plan for
                        Employees){' '}
                      </li>
                      <li>
                        SARSEP (Salary Reduction Simplified Employee Pension
                        Plan){' '}
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What&apos;s the difference between reporting on Form 5498
                  vs Form 1099-R?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="div" sx={{ mt: 2 }}>
                      <TableContainer
                        sx={{ border: '1px solid #828282', borderRadius: 2 }}
                      >
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                }}
                              >
                                Feature
                              </TableCell>

                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                }}
                              >
                                Form 5498
                              </TableCell>

                              <TableCell
                                sx={{
                                  color: '#444',
                                  fontWeight: 600,
                                  width: 300,
                                  textAlign: 'center',
                                  borderBottom: '1px solid #828282',
                                }}
                              >
                                Form 1099-R
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                Purpose
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Reports IRA contributions and account values
                              </TableCell>

                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Reports distributions from retirement plans
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                Who Issues it
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                IRA custodians (banks, investment firms)
                              </TableCell>

                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Financial institutions or plan administrators
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                Who receives It
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                IRA holders and the IRS
                              </TableCell>

                              <TableCell
                                sx={{
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                Recipients of distributions and the IRS
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                What it reports
                              </TableCell>

                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  borderBottom: '1px solid #828282',
                                  textAlign: 'left',
                                  backgroundColor: '#fff',
                                }}
                              >
                                <Box
                                  component="ul"
                                  sx={{ '& li': { mb: 1.2 } }}
                                >
                                  <li>IRA contributions </li>
                                  <li>Rollovers </li>
                                  <li>Roth conversions</li>
                                  <li>
                                    Required Minimum Distribution
                                    (RMD)information{' '}
                                  </li>
                                  <li>Fair market value of account </li>
                                </Box>
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: 'left',
                                  backgroundColor: '#fff',
                                  borderBottom: '1px solid #828282',
                                }}
                              >
                                <Box
                                  component="ul"
                                  sx={{ '& li': { mb: 1.2 } }}
                                >
                                  <li>Distributions from retirement plans </li>
                                  <li>Early Withdrawals </li>
                                  <li>Direct rollovers </li>
                                  <li>Taxable amount of distribution</li>
                                </Box>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',
                                  backgroundColor: '#fff',
                                  textAlign: 'center',
                                }}
                              >
                                Due Date
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderRight: '1px solid #828282',

                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                <span style={{ fontWeight: 600 }}> June 1</span>{' '}
                                (to the IRS and recipients)
                              </TableCell>

                              <TableCell
                                sx={{
                                  textAlign: 'center',
                                  backgroundColor: '#fff',
                                }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  February 2
                                </span>{' '}
                                (to recipients),{' '}
                                <span style={{ fontWeight: 600 }}> Mar 2</span>{' '}
                                (paper) /{' '}
                                <span style={{ fontWeight: 600 }}>Mar 31</span>{' '}
                                (e-file) (to IRS)
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                      Form 5498 reports what goes{' '}
                      <span style={{ fontWeight: 600 }}> into</span> an IRA,
                      while{' '}
                      <Link
                        href="/resources/information-returns/form-1099-r-instructions/"
                        sx={{ color: '#2020ff' }}
                      >
                        Form 1099-R
                      </Link>{' '}
                      reports what comes{' '}
                      <span style={{ fontWeight: 600 }}>out</span> of it.{' '}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What information is required to e-file IRS Form 5498?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.5 } }}>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Trustee or Issuer Information –
                        </span>{' '}
                        Name, TIN, and Address.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Participant Information –
                        </span>{' '}
                        Name, TIN, Address, and Account Number.
                      </li>
                      <li>
                        <span style={{ fontWeight: 600 }}>
                          Contribution and Account Details
                        </span>
                      </li>
                      <ul>
                        <li>IRA Contributions </li>
                        <li>Rollover Contributions </li>
                        <li>Roth IRA Conversions amount </li>
                        <li>Recharacterized Contributions </li>
                        <li>Fair Market Value (FMV) </li>
                        <li>Required Minimum Distributions (RMDs)</li>
                      </ul>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ mb: 5, textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
              }}
            >
              Still have questions?
            </Typography>
            <Typography variant="body1" sx={{ textAlign: 'center' }}>
              <span style={{ fontWeight: 600 }}>
                If you&apos;re looking for more answers
              </span>{' '}
              , refer to our{' '}
              <Link
                href="https://support.taxzerone.com/"
                target="_blank"
                sx={{ color: '#0202ff' }}
              >
                Knowledge Base & FAQs
              </Link>{' '}
              page or get in touch with our customer support team.
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,

                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href="/contact-us/"
            >
              Contact Us
            </Button>
          </Grid>
          <Grid size={12} textAlign="center" sx={{ mb: 2 }}>
            <Divider />
          </Grid>
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
              }}
            >
              Related Resources
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box
              sx={{
                border: '1px solid #eaeaea',
                p: 1.5,
                backgroundColor: '#f0f2f9',
                pb: { xs: 2, sm: 2 },
                borderRadius: 3,
                minHeight: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: 16, md: 18 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                }}
              >
                Form 5498 Instructions
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                }}
              >
                Refer to the{' '}
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-instructions/`}
                  sx={{ color: '#0202ff' }}
                >
                  Form 5498 Instructions
                </Link>{' '}
                for an easy and accurate filing with TaxZerone.
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Box
              sx={{
                border: '1px solid #eaeaea',
                p: 1.5,
                backgroundColor: '#f0f2f9',
                pb: { xs: 2, sm: 2 },
                borderRadius: 3,
                minHeight: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: { xs: 16, md: 18 },
                  mb: { xs: 1, sm: 1 },
                  fontWeight: 600,
                }}
              >
                Form 5498 Due Date
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                }}
              >
                Learn more about the{' '}
                <Link
                  href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}resources/information-returns/form-5498-due-dates/`}
                  sx={{ color: '#0202ff' }}
                >
                  Form 5498 due date
                </Link>{' '}
                and ensure timely submission with TaxZerone.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form5498;
